import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatCalendar } from "@angular/material/datepicker";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";
import { UserSettingsQuery } from "@timeghost/web-api";
import { BehaviorSubject } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import { TimeDatePickerConfig } from "./time-date-picker-config";

@Component({
	selector: "app-time-date-picker",
	templateUrl: "./time-date-picker.component.html",
	styleUrls: ["./time-date-picker.component.scss"],
})
export class TimeDatePickerComponent implements OnInit, AfterViewInit {
	@ViewChild("calview", { static: true })
	calendar: MatCalendar<Date>;
	private _selectedDate = new BehaviorSubject<Date>(null);
	readonly selectedDate$ = this._selectedDate.asObservable().pipe(distinctUntilChanged());
	get selectedDate() {
		return this._selectedDate.getValue();
	}
	set selectedDate(val: Date) {
		this._selectedDate.next(val);
	}
	private _minDate = new BehaviorSubject<Date>(null);
	readonly minDate$ = this._minDate.asObservable().pipe(distinctUntilChanged());
	get minDate() {
		return this._minDate.getValue();
	}
	set minDate(val: Date) {
		this._minDate.next(val);
	}
	private _maxDate = new BehaviorSubject<Date>(null);
	readonly maxDate$ = this._maxDate.asObservable().pipe(distinctUntilChanged());
	get maxDate() {
		return this._maxDate.getValue();
	}
	set maxDate(val: Date) {
		this._maxDate.next(val);
	}

	constructor(
		@Inject(MAT_DIALOG_DATA)
		private data: TimeDatePickerConfig,
		private userSettingsQuery: UserSettingsQuery,
		private ref: MatDialogRef<TimeDatePickerComponent>
	) {}

	ngOnInit(): void {
		if (this.data.selectedDate) this.selectedDate = this.data.selectedDate;
		if (this.data.minDate) this.minDate = this.data.minDate;
		if (this.data.maxDate) this.maxDate = this.data.maxDate;

		this.ref.addPanelClass("mat-dialog-nopad"), this.ref.updateSize("320px", "400px");
	}
	ngAfterViewInit() {
		if (!this.data.selectedDate) {
			this.calendar.monthView.activeDate = new Date();
		}
	}
	close(val: Date) {
		return this.ref.close(val);
	}
}
